module.exports = __webpack_public_path__ + "static/img/tfs-logo-optimized.158b366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tfs-logo-optimized.jpg
// module id = 381
// module chunks = 3